export default {
  drawerTitle: {
    id: 'review-photos-guidance-drawer-title',
    defaultMessage: 'Condition photos',
  },
  gradeTitle: {
    id: 'review-photos-guidance-grade-title',
    defaultMessage: 'What {grade} condition looks like',
  },
  exampleTag: {
    id: 'review-photos-guidance-example-tag',
    defaultMessage: 'Example of {grade} condition (body, screen)',
  },
  subtitle: {
    id: 'review-photos-guidance-subtitle',
    defaultMessage: 'Photos from verified reviews',
  },
  alternativeNext: {
    id: 'review-photos-guidance-next',
    defaultMessage: 'Next',
  },
  alternativePrevious: {
    id: 'review-photos-guidance-previous',
    defaultMessage: 'Previous',
  },
  tabPremium: {
    id: 'review-photos-guidance-tab-premium',
    defaultMessage: 'Premium',
  },
  tabFlawless: {
    id: 'review-photos-guidance-tab-flawless',
    defaultMessage: 'Excellent',
  },
  tabVeryGood: {
    id: 'review-photos-guidance-tab-very-good',
    defaultMessage: 'Good',
  },
  tabEco: {
    id: 'review-photos-guidance-tab-eco',
    defaultMessage: 'Fair',
  },
  tabsLabel: {
    id: 'review-photos-guidance-tabs-label',
    defaultMessage: 'Reviews photos by condition',
  },
  carouselController: {
    id: 'review-photos-guidance-carousel-controller',
    defaultMessage: 'Photo carousel controller',
  },
  defaultCardDescription: {
    id: 'review-photos-guidance-default-card-description',
    defaultMessage:
      'This is an example of a product in {grade} condition. Browse photos from verified reviews to see what this condition looks like.',
  },
  noReviewsCardTitle: {
    id: 'review-photos-guidance-no-reviews-card-title',
    defaultMessage: '{grade} condition in real life',
  },
  noReviewsCardDescription: {
    id: 'review-photos-guidance-no-reviews-card-description',
    defaultMessage: 'No review photos available yet.',
  },
}
